export default ({ initial = '', doneSteps = [] } = {}) => ({
  current: initial,
  doneSteps: [...doneSteps],

  init() {
    this.$watch('current', () => this.broadcast())
    this.broadcast()
  },

  open(name) {
    if (this.state(name) === 'locked') return
    this.current = name
  },

  next(name) {
    if (!this.doneSteps.includes(this.current))
      this.doneSteps.push(this.current)
    if (name) this.current = name
  },

  state(name) {
    if (this.current === name) return 'current'
    if (this.doneSteps.includes(name)) return 'done'
    return 'locked'
  },

  broadcast() {
    this.$dispatch('accordion:change', { current: this.current })
  },
})
